export const getShopGroupFromOrder = (order) => {
    if (order.origin === "PrestaShop") {
        return "PZ";
    }
    else if (order.origin === "Odoo") {
        return "Longtail";
    }
    else {
        return order.shop;
    }
};
